import idx from 'idx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers, withStateHandlers, lifecycle } from 'recompose'

import * as groupModule from 'modules/group'


export default compose(
  connect(
    (state) => {
      return {
        groups: idx(state, _ => _.groups.items),
        organisation: idx(state, _ => _.organisation.selected)
      }
    }, 
    (dispatch) => {
      const actions = {
        ...groupModule,
      }
      return {
        actions: bindActionCreators(actions, dispatch),
      }
    }, 
  ),
  withStateHandlers(
    () => ({
      loaded: true,
      selectedGroup: null,
    }),
    {
      setState: state => object => ({
        ...state,
        ...object
      }),
      onSearchChange: () => value => ({
        search: [{ key: 'name', value }],
        loaded: false
      }),
    }
  ),
  withHandlers({
    onGroupSelect: ({ setState, groups }) => (selectedGroup) => {
      setState({
        selectedGroup: groups[selectedGroup],
      })
    },
    onConfirmClick: ({ data, selectedGroup }) => () => {
      data.onConfirm(selectedGroup)
    } 
  }),
  
  lifecycle({
    componentDidMount() {
      const { actions, organisation } = this.props
      actions.getGroups(organisation)
    },
    componentDidUpdate(prevProps) {
      const {
        actions, search, setState, loaded, organisation 
      } = this.props

      if (prevProps.search !== search && !loaded) {
        actions.getGroups(organisation, { search }, () => {
          setState({ loaded: true })
        })
      }
    }
  }),
)



// WEBPACK FOOTER //
// ./src/components/organisms/AssignTrapsPopover/AssignTrapsPopover.enhancer.js